<template>
  <div class="share-wraper">
    <TxButton v-if="is_show" class="share" src="anniu" @click="handle_share" name="分享按钮">
      点击分享
    </TxButton>
    <TxDialog v-model="is_show">
      <div class="dialog-content">
      
      </div>
    </TxDialog>
  </div>
</template>
<script setup>
import eventEmitter from '@utils/event';
import { onMounted } from 'vue';
const is_show = ref(false);
const {
  is_login
} = inject('GlobalData');
const { channel } = inject('GlobalStore');

defineProps({
  is_show:{
    type:Boolean,
    default:true
  }
})

function handle_share() {
  // 检查是否是微信环境
  if (channel.channel != 'wx') {
    eventEmitter.emit('showCommomTipModal', 'copyLink');
    return;
  }

  // 检查是否登录
  if (!is_login.value) {
    eventEmitter.emit('login');
    return;
  }
  // 重新注册事件

  // 拉起引导页
  is_show.value = true;
}
onMounted(() => {
  eventEmitter.on('show_share', () => {
    is_show.value = true
  })
})
</script>
<style lang="scss" scoped>
.share {
  font-size: 30px;
}

.share-wraper {
  // display: inline-flex;
}

.dialog-content {
  padding-top: 20px;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
  position: absolute;
  right: 0;
  top: 0;
  // @include bg('POPO-20251124-112224');
}
</style>
